module.exports = __webpack_public_path__ + "components/weather-icon/static/daymodrain-1ff618445321fff0ee4e4a8db1c9a827.webp";